import * as AvatarPrimitive from '@radix-ui/react-avatar';
import * as BoringAvatars from 'boring-avatars';
import * as React from 'react';

import { cn } from './lib/utils';

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn('relative flex shrink-0 overflow-hidden rounded bg-slate-500', className)}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  );
}

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn('flex size-full items-center justify-center text-white', className)}
      {...props}
    />
  );
}

function AvatarBeam({
  id,
  name,
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root> & { id: string; name: string }) {
  return (
    <Avatar className={cn('size-12 rounded not-first:-ml-6 z-0 border', className)} {...props}>
      <AvatarImage src={id} alt={name} />
      <AvatarFallback>
        <BoringAvatars.default name={name} variant="beam" size={128} square />
      </AvatarFallback>
    </Avatar>
  );
}

export { Avatar, AvatarBeam, AvatarFallback, AvatarImage };
